/*
 * @license
 * Copyright© Celligence LLC - 2023
 * 
 * This software program is protected by copyright laws and is the property of
 * Celligence LLC (Celligence). Any unauthorized reproduction,
 * distribution, modification, or public display of this program, without the
 * explicit permission of Celligence is strictly prohibited. If you have gained
 * access to this program without the expressed approval of Celligence report
 * the incident to legal@celligence.com.
 * 
 */

/**
 * @author Pratik Kajrolkar 
 * @date 06/06/2024
 * 
 * Determines whether the device accessing the page is a mobile.
 *
 * @return {boolean} Returns true if the device is a mobile, false otherwise.
 */
function isMobileDevice() {
    const width = window.innerWidth;
    const isMobile = width < 992; // Adjust the value as needed
    return isMobile;
}

module.exports = {
    isMobileDevice
};
